module.exports = __webpack_public_path__ + "static/assets/c20d558f1fc823a96de910456827d90c.mp3";